const _scopedState = state => state.entities.workspace;

const activeWorkspace = state => _scopedState(state).activeWorkspace;
const canAdministerWinner = state => _scopedState(state).activeWorkspace.canAdministerWinner;

export default {
  activeWorkspace,
  canAdministerWinner,
};
